module.exports = __webpack_public_path__ + "static/media/NIVEL_RIESGO_F1.b95dc35c.svg";